// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__3gnKG","pos":"Placeholder_pos__29WPs","logo":"Placeholder_logo__37dy8","desc":"Placeholder_desc__22B58"};